<template>
  <div class="pop-box" ref="userRef" >
    <!-- <span class="pop-close iconfont icon-close-fill"  @click="hidePop"></span> -->
    
    <keep-alive>
      <component :is="currentComponent" @changeView="changeView" @hideView="hidePop" ref="userRight" />
    </keep-alive>
    <!-- 
    <user-rights />
    <reset-pwd /> -->
  </div>
</template>

<script>
import ResetPwd from '../components/common/resetPwd.vue'
import UserRights from '../components/common/userRights.vue'
import {mapState, mapMutations} from 'vuex'
export default {
  name: 'popUser',
  props: {
    msg: String,
    showUser:Boolean
  },
  components:{
    UserRights,
    ResetPwd  
  },
  data(){
    return{
      currentComponent:'UserRights'
    }
  },
  computed:{
    ...mapState(['userInfo'])
  },
  mounted(){
    this.checkLoginState()
    // document.addEventListener('click',this.outClick);
  },
  methods: {
    ...mapMutations(['updateUserInfo']),
    checkLoginState(){
      if(this.userInfo && JSON.stringify(this.userInfo)!='{}'){
        this.currentComponent = UserRights;
      }
    },
    hidePop(){
      this.$emit("hidePop")
    },

    changeView(info){
      // console.log(info)
      this.currentComponent = info.viewName
    },

    // 点击外部收起下拉选框
    outClick(e){
      // console.log(this.$refs.dropRef)
      // let dropRef= this.$refs.dropRef.$el
      
      let userRef= this.$refs.userRef;
      if( e.target.className.indexOf('user-btn')>=0 || e.target.className.indexOf("iconfont icon-renwu")>=0 || e.target.className.indexOf('default-img')>=0){
        return;
      }
      try{
        if(userRef && !userRef.contains(e.target) && this.showUser ){
         this.hidePop()
      }
      }catch(err){}

      // console.log(userRef.contains(e.target))
      
      
    },
  },
}
</script>
<style scoped >


</style>